module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Terms of Service"},"es":{"title":"Condiciones de uso"},"fr":{"title":"Conditions Générales d\u0027Utilisation"},"it":{"title":"Condizioni di utilizzo"},"pt":{"title":"Condições de Utilização"},"pl":{"title":"Warunki korzystania z usługi"}}')
  delete Component.options._Ctor
}
